export default function SortAscIcon({ className = '' }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
    >
      <path d="M10 14l-5-5h10l-5 5z" />
    </svg>
  );
}
